import { render, staticRenderFns } from "./AdditionalModifierOptions.vue?vue&type=template&id=1c60ba3e&scoped=true&"
import script from "./AdditionalModifierOptions.vue?vue&type=script&lang=js&"
export * from "./AdditionalModifierOptions.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalModifierOptions.vue?vue&type=style&index=0&id=1c60ba3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60ba3e",
  null
  
)

export default component.exports